import { notification } from "ant-design-vue";

function notifySuccess(title, message) {
    notification.config({
        placement: "topLeft"
    })
    notification.destroy()
    notification.success({
        message: title,
        description: message
    });
}

function notifyWarning(title, message) {
    notification.config({
        placement: "topLeft"
    })
    notification.destroy()
    notification.warning({
        message: title,
        description: message
    });
}

export {
    notifySuccess,
    notifyWarning
}
